import React from "react";

export default function TermCondition() {
  return (
    <div className="py-0">
      <div className="text-sm text-gray-500 mb-10">
        Home <span className="mx-2">/</span>
        Our Policies <span className="mx-2">/</span>
        <span className="text-black">Terms & Conditions</span>
      </div>

      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-left">
          Terms & Conditions
        </h1>

        <div className="w-full h-[1px] bg-gray-300 mx-auto mt-2"></div>

        <p className="text-sm text-gray-500 mt-2">
          Last Updated: 29 April 2026
        </p>
      </div>

      <div className="space-y-8 text-sm leading-7 text-gray-800">

        <section>
          <p>
            Welcome to Happenhood (“Platform”), owned and operated by Aimbeyond Infotech Private Limited, New Delhi, India.
            By accessing or using our website or mobile application, you (“User”, “you”) agree to be bound by these Terms & Conditions (“Terms”).
          </p>
        </section>

        {/* 1 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            1. Services
          </h2>
          <p>Happenhood enables users to:</p>
          <ul className="list-disc pl-5">
            <li>Discover events</li>
            <li>Post Events</li>
            <li>Reserve or book tickets</li>
            <li>Access event-related information</li>
          </ul>
          <p className="mt-2">
            The Platform acts solely as an intermediary that enables Users to discover events and reserve tickets offered by third-party event organizers (“Organizers”).
          </p>
          <p>
            We do not own, operate, or control the events listed on the Platform.
          </p>
        </section>

        {/* 2 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            2. User Obligations
          </h2>
          <p>You agree to:</p>
          <ul className="list-disc pl-5">
            <li>Provide accurate and complete information</li>
            <li>Maintain the confidentiality of your account</li>
            <li>Use the Services only for lawful purposes</li>
          </ul>
          <p className="mt-2">
            You are solely responsible for all activities under your account.
          </p>
        </section>

        {/* 3 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            3. Booking, Tickets, and Payments
          </h2>

          <p className="font-semibold">3.1 Free Events</p>
          <ul className="list-disc pl-5">
            <li>Bookings for free events are deemed confirmed upon issuance of a confirmation by the Platform.</li>
            <li>Entry remains subject to verification at the venue and compliance with Organizer policies.</li>
          </ul>

          <p className="font-semibold mt-3">3.2 Paid Events (Pay at Venue Model)</p>
          <ul className="list-disc pl-5">
            <li>The Platform currently does not process online payments.</li>
            <li>Bookings for paid events constitute a reservation only and do not guarantee entry.</li>
            <li>Users must complete payment directly at the venue to gain entry.</li>
            <li>Failure to make payment may result in denial of entry without liability to the Platform.</li>
          </ul>
        </section>

        {/* 4 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            4. No-Show and Seat Release
          </h2>
          <p>Organizers reserve the right to:</p>
          <ul className="list-disc pl-5">
            <li>Cancel reservations</li>
            <li>Reallocate seats</li>
          </ul>
          <p className="mt-2">if Users fail to:</p>
          <ul className="list-disc pl-5">
            <li>Arrive within the specified time</li>
            <li>Complete payment (where applicable)</li>
          </ul>
          <p className="mt-2">
            The Platform shall not be liable for any such actions.
          </p>
        </section>

        {/* 5 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            5. Event Changes and Cancellations
          </h2>
          <p>All events are managed by Organizers. The Platform is not responsible for:</p>
          <ul className="list-disc pl-5">
            <li>Event cancellations</li>
            <li>Schedule changes</li>
            <li>Venue modifications</li>
          </ul>
          <p className="mt-2">
            Users acknowledge that such changes are outside the Platform’s control.
          </p>
        </section>

        {/* 6 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            6. Platform Disclaimer
          </h2>
          <p>The Platform acts solely as a facilitator and makes no representations or warranties regarding:</p>
          <ul className="list-disc pl-5">
            <li>Event quality</li>
            <li>Accuracy of event information</li>
            <li>Safety or suitability of events</li>
          </ul>
          <p className="mt-2">
            All interactions and transactions are between Users and Organizers.
          </p>
        </section>

        {/* 7 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            7. Indemnification
          </h2>
          <p>You agree to indemnify and hold harmless the Company and its affiliates from any claims, damages, or losses arising from:</p>
          <ul className="list-disc pl-5">
            <li>Your use of the Services</li>
            <li>Violation of these Terms</li>
            <li>Your interactions with Organizers</li>
          </ul>
        </section>

        {/* 8 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            8. Suspension and Termination
          </h2>
          <p>
            We reserve the right to suspend or terminate access to the Services at our sole discretion, without prior notice, for violations of these Terms.
          </p>
        </section>

        {/* 9 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            9. Future Services
          </h2>
          <p>
            The Platform may introduce online payment features or additional services in the future. Continued use of such features will be subject to updated Terms.
          </p>
        </section>

        {/* 10 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            10. Intellectual Property
          </h2>
          <p>
            All content, trademarks, branding, and technology on the Platform are owned by or licensed to Aimbeyond Infotech Private Limited and may not be used without prior written permission.
          </p>
        </section>

        {/* 11 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            11. Governing Law and Jurisdiction
          </h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of India.
          </p>
          <p>
            Any disputes shall be subject to the exclusive jurisdiction of the courts located in New Delhi.
          </p>
        </section>

        {/* 12 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            12. Changes to Terms
          </h2>
          <p>
            We reserve the right to modify these Terms at any time. Continued use of the Services constitutes acceptance of the revised Terms.
          </p>
        </section>

        {/* 13 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            13. Contact Information
          </h2>
          <p>Company Name: Aimbeyond Infotech Private Limited</p>
          <p>Brand Name: Happenhood</p>
          <p className="text-blue-500">Email: support@happenhood.com</p>
          <p>Address: L26H, Sheikh Sarai, Phase 2, New Delhi 110017</p>
        </section>

      </div>
    </div>
  );
}